import { render, staticRenderFns } from "./TransactionDetails.vue?vue&type=template&id=973b3050&scoped=true&"
import script from "./TransactionDetails.vue?vue&type=script&lang=tsx&"
export * from "./TransactionDetails.vue?vue&type=script&lang=tsx&"
import style0 from "./TransactionDetails.vue?vue&type=style&index=0&id=973b3050&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973b3050",
  null
  
)

export default component.exports